import { create } from 'zustand';

export interface QuizAnswer {
  questionId: string;
  value: string | string[];
}

interface QuizState {
  currentStep: number;
  answers: QuizAnswer[];
  variant: string;
  setVariant: (variant: string) => void;
  setStep: (step: number) => void;
  nextStep: () => void;
  prevStep: () => void;
  addAnswer: (answer: QuizAnswer) => void;
  reset: () => void;
}

export const useQuizStore = create<QuizState>((set) => ({
  currentStep: 0,
  answers: [],
  variant: 'default',
  setVariant: (variant) => set({ variant }),
  setStep: (step) => set({ currentStep: step }),
  nextStep: () => set((s) => ({ currentStep: s.currentStep + 1 })),
  prevStep: () => set((s) => ({ currentStep: Math.max(0, s.currentStep - 1) })),
  addAnswer: (answer) =>
    set((s) => ({
      answers: [...s.answers.filter((a) => a.questionId !== answer.questionId), answer],
    })),
  reset: () => set({ currentStep: 0, answers: [], variant: 'default' }),
}));
